import { getMqttSource } from '@/lib/mqtt/source';
import type { RawMqttMessage } from '@/lib/mqtt/types';
import { useDebugStore } from '@/lib/store/debug';
import { useEffect } from 'react';
import type { DebugScope } from '../useDebugScope';

/** Tap the raw MQTT stream while the Debug Logs panel is mounted, keeping only
 *  the messages in the current scope (the active tab's displayed topics), and
 *  rAF-coalesce them into the debug store. Resets when the scope changes so the
 *  tree/messages don't mix across tabs or selections. */
export function useDebugFeed(scope: DebugScope) {
  useEffect(() => {
    useDebugStore.getState().clear();
    const src = getMqttSource();
    let queue: RawMqttMessage[] = [];
    let raf = 0;
    const flush = () => {
      raf = 0;
      const batch = queue;
      queue = [];
      if (batch.length) useDebugStore.getState().ingestBatch(batch);
    };
    const unsub = src.subscribeRaw((msg) => {
      if (!scope.match(msg.topic)) return;
      queue.push(msg);
      if (!raf) raf = requestAnimationFrame(flush);
    });
    return () => {
      unsub();
      if (raf) cancelAnimationFrame(raf);
    };
  }, [scope]);
}
